import { Grid } from "semantic-ui-react";
import moment from "moment-with-locales-es6";
moment.locale("fr");

const styles = {
	patientLabelGrid: {
		textAlign: "right",
		paddingRight: "10px",
		fontWeight: "bold",
		fontSize: "0.9em",
		width: "150px",
		padding: "3px 3px",
	},
	patientValueGrid: {
		textAlign: "left",
		fontSize: "0.9em",
		wordWrap: "break-word",
		padding: "3px 3px",
	},
};

const PatientData = ({ patient, type }) => {
	if (patient)
		return (
			<Grid key={`grid-${patient.id}-${type}`} style={{ padding: "10px" }}>
				<Grid.Row columns={2}>
					{patient.is_dead && patient.is_dead !== "N" && (
						<Grid.Column width={16} style={{ display: "flex", justifyContent: "center" }}>
							<span style={{ color: "red" }}>! personne décédée !</span>
						</Grid.Column>
					)}
					<Grid.Column style={styles.patientLabelGrid}> Nom de naissance: </Grid.Column>
					<Grid.Column style={styles.patientValueGrid}>
						{" "}
						{(!!patient.birth_name && patient.birth_name.toUpperCase()) ||
							(type === "mylab" && !!patient.last_name && patient.last_name.toUpperCase()) ||
							"-"}
					</Grid.Column>
					<Grid.Column style={styles.patientLabelGrid}> Nom marital: </Grid.Column>
					<Grid.Column style={styles.patientValueGrid}>
						{" "}
						{(type === "mylab" && !!patient.marital_name && patient.marital_name.toUpperCase()) ||
							(type !== "mylab" && patient.birth_name !== patient.last_name && !!patient.last_name && patient.last_name.toUpperCase()) ||
							"-"}
					</Grid.Column>
					<Grid.Column style={styles.patientLabelGrid}> Prénom: </Grid.Column>
					<Grid.Column style={styles.patientValueGrid}>{patient.first_name || "-"}</Grid.Column>
					<Grid.Column style={styles.patientLabelGrid}> Genre: </Grid.Column>
					<Grid.Column style={styles.patientValueGrid}>
						{(patient.gender === "male" || patient.gender === "m" || patient.gender === "M") && "Homme"}{" "}
						{patient.gender !== "male" && patient.gender !== "m" && patient.gender !== "M" && "Femme"}
					</Grid.Column>
					<Grid.Column style={styles.patientLabelGrid}> Date de naissance: </Grid.Column>
					<Grid.Column style={styles.patientValueGrid}>{patient.birth_date ? moment(patient.birth_date).format("DD MMMM YYYY") : "-"}</Grid.Column>
					<Grid.Column style={styles.patientLabelGrid}> Téléphone: </Grid.Column>
					<Grid.Column style={styles.patientValueGrid}>{patient.mobile_phone || patient.mobilephone || patient.phone} </Grid.Column>
					<Grid.Column style={styles.patientLabelGrid}> Email: </Grid.Column>
					<Grid.Column style={styles.patientValueGrid}>{patient.email || "-"}</Grid.Column>
					<Grid.Column style={styles.patientLabelGrid}> N° pièce d'identité: </Grid.Column>
					<Grid.Column style={styles.patientValueGrid}>{patient.identity_number || "-"}</Grid.Column>
					<Grid.Column style={styles.patientLabelGrid}> Matricule: </Grid.Column>
					<Grid.Column style={styles.patientValueGrid}>{patient.matricule || patient.cns || "-"}</Grid.Column>
				</Grid.Row>
			</Grid>
		);
};

export default PatientData;
